import React from "react";
import PageHeader from "../PageHader/PageHeader";
import ControlledAccordions from "./ControlledAccordions";
import Footer from "../Footer";
import { ArrowSmDownIcon } from "@heroicons/react/outline";
import Certificate from "../../Page/HomePage/Certification"
const MySkill = () => {
  const d = new Date();
  let year = d.getFullYear();
  return (
    <center>
      <PageHeader back="Back" text="My Skills && Certification" />
      <div className=" p-6 m-3    w-full md:p-0 md:m-0">
        <div className="flex flex-col-reverse  justify-center lg:ml-[64px]  lg:flex-row ">
          <div className=" mt-8 lg:w-[50%] ">
           <Certificate/>
            <div>
            <p className="text-[#17A6DB] dark:text-[#30dada] flex justify-center text-[16px] py-4 px-4  md:text-[18pxl] lg:text-[20px] mt-2 ">
            If you want to know more about me just click on footer icons.<ArrowSmDownIcon className="w-5 ml-2" /> </p>
            </div>
            <div>
              
            </div>
          </div>
          
          <div className=" mt-8   lg:w-[50%] lg:mt-8">
            <ControlledAccordions />
          </div>
        </div>
      </div>
      <div className=" mt-[70px] md:mt-[40px] md:block lg:mt-[10px] ">
        <p className="text-[#17A6DB] dark:text-[#30dada] flex justify-center md:pb-0">
        Developed  and Design @{year} by Deepesh Kumar. 
        </p>
        <Footer />
      </div>
    </center>
  );
};

export default MySkill;
